import React, { useEffect, useRef, useState } from 'react'
import { PageHeader, Form, Row, Col, Input, Select, Button, message } from 'antd'
import { useParams, useNavigate } from 'react-router-dom';
import { UserAddOutlined, LeftCircleOutlined  } from '@ant-design/icons';
import { useApiContext } from "../../hooks/useApiContext";
import moment from "moment";
import apis from "../../services/apis";

export default function EditEmployee() {
  const { employeedispatch, projectdispatch, projects, clientdispatch, clients} = useApiContext()
  const {id} = useParams()
  const navigate = useNavigate()
  const [employeeform] = Form.useForm()
  const [employeeData, setEmployeeData] = useState()
  const [employeeId, setEmployeeId] = useState("")
  const [projectData, setProjectData] = useState([])
  const [loading, setLoading] = useState(false)
  const [employeeRegId, setEmployeeRegId] = useState("")

  useEffect(()=>{
    if(projects.length<1) apis.Projects.list(projectdispatch)
    if(clients.length<1) apis.Clients.list(clientdispatch)
    if(id){
      apis.Employees.get(id).then(res=> {
        console.log("data", res.data)
        setEmployeeData(res.data)
        setEmployeeId(res.data.id)
        setEmployeeRegId(res.data.empId)
        setProjectData(projects.filter(x=>x.companyId == res.data.projectId))
        employeeform.setFieldsValue({
          fullName: res.data.fullName,
          basicSalary: res.data.basicSalary,
          category:res.data.category,
          mobileNumber: res.data.mobileNumber,
          borderNumber:res.data.borderNumber,
          gender:res.data.gender,
          entryDate:moment(res.data.entryDate).format('YYYY-MM-DD'),
          nationality: res.data.nationality,
          dob: moment(res.data.dob).format('YYYY-MM-DD'),
          molId: res.data.molId,
          iqamaNumber:Number(res.data.iqamaNumber),
          passportNumber: res.data.passportNumber,
          workShift: res.data.workShift,
          experience: res.data.experience,
          leavePolicy: res.data.leavePolicy,
          reference: res.data.reference,
          remarks: res.data.remarks,
          companyId:res.data.companyId
        })
      })

    
      
    }
  },[id])
 
  const handleCompanyChange =(value)=>{
    const getProject= projects.filter(x=>x.companyId == value)
    setProjectData(getProject)
  }
  const onFinish=(values)=>{
    setLoading(true)
    let newValue = {...values, id:employeeId, empId: employeeRegId}
    apis.Employees.edit(employeedispatch, newValue).then(res=>{
      message.success("Employee Update successfully")
      setLoading(false)
    })
      //console.log(newValue);
  }
  const onFinishFailed=(error)=>{
      message.error(error)
  }

  return (
    <>
     <PageHeader
    className="site-page-header"
    onBack={() => navigate(-1)}
    title="Edit Employee"
    subTitle="Enter details to Update employee"

    
  />
  <Form
              initialValues={{remember: true}}
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              labelCol={{span:8}}
              wrapperCol={{span:16}}
              form={employeeform}
              >
      <Row className='p-20'>

      <Col span={12}>
      <Form.Item
      label="Employee Id"
      >
        <label>{employeeRegId}</label>
        </Form.Item>
      <Form.Item
        label="Full Name"
        name="fullName"
        hasFeedback
        rules={[{ required: true, message: 'Please enter fullname', min:4 , message:'Enter minimum 4 characters' }]}
      >
        <Input />
      </Form.Item>
   
      <Form.Item
        label="Border Number"
        name="borderNumber"
        hasFeedback
        rules={[{ required: true, message: 'Please enter Border Number', min:10 , message:'Enter minimum 10 characters' }]}
        
      >
        <Input type="number"/>
      </Form.Item>
      <Form.Item
        label="Mobile Number"
        name="mobileNumber"
        hasFeedback
        rules={[{  min:10 , message:'Enter minimum 10 digits' }]}
      >
        <Input type="number"/>
      </Form.Item>
      <Form.Item
        label="Gender"
        name="gender"
        hasFeedback
      >
        <Select defaultValue="Select Gender">
            <Select.Option key="Male">Male</Select.Option>
            <Select.Option key="Female">Female</Select.Option>
        </Select>
      </Form.Item>
      <Form.Item
        label="Nationality"
        name="nationality"
        hasFeedback
      >
        <Input/>
      </Form.Item>
      <Form.Item
        label="Date of birth"
        name="dob"
        hasFeedback
        
      >
        <Input type="date"/>
      </Form.Item>
      <Form.Item
        label="MOL ID"
        name="molId"
        hasFeedback
        rules={[{  min:4 , message:'Enter minimum 4 characters' }]}
      >
        <Input type="number"/>
      </Form.Item>
      <Form.Item
        label="Passport Number"
        name="passportNumber"
        hasFeedback
        
      >
        <Input/>
      </Form.Item>
      <Form.Item
        label="Experience"
        name="experience"
        hasFeedback
        
      >
        <Input/>
      </Form.Item>
    
      <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button loading={loading} type="primary" htmlType="submit" icon={<UserAddOutlined />} style={{marginRight:'5px'}}>
          Update Employee
        </Button> 
        <Button   icon={<LeftCircleOutlined />} >
          Back
        </Button> 
        </Form.Item>
      </Col>
      <Col span={12}>
      <Form.Item
        label="Company Name"
        name="companyId"
        hasFeedback
        warningOnly
        rules={[{required:true, message:"Please select Company Name"}]}
      >
        <Select placeholder="Select Company" onChange={handleCompanyChange}>
          {clients.map(item => (
            <Select.Option value={item.id}>{item.companyName}</Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label="Project Name"
        name="projectId"
        hasFeedback
        warningOnly
        rules={[{required:true, message:"Please select Project Name"}]}
      >
        <Select placeholder="Select Project">
          {projectData.map(item=>(
            <Select.Option value={item.id}>{item.projectName}</Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label="Category"
        name="category"
        hasFeedback 
      >
        <Input/>
      </Form.Item>
     
     
      <Form.Item
        label="Entry Date"
        name="entryDate"
        hasFeedback
      >
        <Input type="date"/>
      </Form.Item>
      <Form.Item
        label="Iqama Number"
        name="iqamaNumber"
        hasFeedback
        warningOnly
        rules={[{  min:10 , message:'Enter minimum 10 characters' }]}
      >
        <Input type="number"/>
      </Form.Item>
      <Form.Item
        label="Basic Salary"
        name="basicSalary"
        hasFeedback
      >
        <Input/>
      </Form.Item>
     
      <Form.Item
        label="Work shift"
        name="workShift"
        hasFeedback
      >
        <Input/>
      </Form.Item>
      <Form.Item
        label="Leave policy"
        name="leavePolicy"
        hasFeedback
      >
        <Input/>
      </Form.Item>
      <Form.Item
        label="Reference/RL"
        name="reference"
        hasFeedback
      >
        <Input/>
      </Form.Item>
      <Form.Item
        label="Remarks"
        name="remarks"
        hasFeedback
      >
        <Input.TextArea rows={2}/>
      </Form.Item>
      </Col>
        </Row>
  </Form>
    </>
  )
}
